module.exports = __webpack_public_path__ + "static/media/subhajit-mandal.aa03ad8e.jpeg";